import React, { useState } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
export function Navbar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };
  return <nav className="bg-white shadow-md sticky top-0 z-50" data-id="element-62">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-63">
        <div className="flex justify-between h-16" data-id="element-64">
          <div className="flex items-center" data-id="element-65">
            <div className="flex-shrink-0 flex items-center" data-id="element-66">
              <span className="text-2xl font-bold text-emerald-600" data-id="element-67">
                UrbanWize
              </span>
            </div>
          </div>
          {/* Desktop menu */}
          <div className="hidden md:flex items-center space-x-8" data-id="element-68">
            <a href="#how-it-works" className="text-gray-700 hover:text-emerald-600 transition-colors" data-id="element-69">
              How It Works
            </a>
            <a href="#features" className="text-gray-700 hover:text-emerald-600 transition-colors" data-id="element-70">
              Features
            </a>
            <a href="#for-hosts" className="text-gray-700 hover:text-emerald-600 transition-colors" data-id="element-71">
              For Hosts
            </a>
            <a href="#for-vendors" className="text-gray-700 hover:text-emerald-600 transition-colors" data-id="element-72">
              For Vendors
            </a>
            <a href="#about" className="text-gray-700 hover:text-emerald-600 transition-colors" data-id="element-73">
              About Us
            </a>
            <a href="#blog" className="text-gray-700 hover:text-emerald-600 transition-colors" data-id="element-74">
              Blog
            </a>
            <a href="#contact" className="bg-emerald-600 text-white px-4 py-2 rounded-md hover:bg-emerald-700 transition-colors" data-id="element-75">
              Sign Up
            </a>
          </div>
          {/* Mobile menu button */}
          <div className="md:hidden flex items-center" data-id="element-76">
            <button onClick={toggleMenu} className="inline-flex items-center justify-center p-2 rounded-md text-gray-700 hover:text-emerald-600 focus:outline-none" data-id="element-77">
              {isMenuOpen ? <XIcon size={24} data-id="element-78" /> : <MenuIcon size={24} data-id="element-79" />}
            </button>
          </div>
        </div>
      </div>
      {/* Mobile menu */}
      {isMenuOpen && <div className="md:hidden bg-white shadow-lg" data-id="element-80">
          <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3" data-id="element-81">
            <a href="#how-it-works" className="block px-3 py-2 text-gray-700 hover:text-emerald-600" onClick={toggleMenu} data-id="element-82">
              How It Works
            </a>
            <a href="#features" className="block px-3 py-2 text-gray-700 hover:text-emerald-600" onClick={toggleMenu} data-id="element-83">
              Features
            </a>
            <a href="#for-hosts" className="block px-3 py-2 text-gray-700 hover:text-emerald-600" onClick={toggleMenu} data-id="element-84">
              For Hosts
            </a>
            <a href="#for-vendors" className="block px-3 py-2 text-gray-700 hover:text-emerald-600" onClick={toggleMenu} data-id="element-85">
              For Vendors
            </a>
            <a href="#about" className="block px-3 py-2 text-gray-700 hover:text-emerald-600" onClick={toggleMenu} data-id="element-86">
              About Us
            </a>
            <a href="#blog" className="block px-3 py-2 text-gray-700 hover:text-emerald-600" onClick={toggleMenu} data-id="element-87">
              Blog
            </a>
            <a href="#contact" className="block px-3 py-2 bg-emerald-600 text-white rounded-md hover:bg-emerald-700" onClick={toggleMenu} data-id="element-88">
              Sign Up
            </a>
          </div>
        </div>}
    </nav>;
}